import {Component, OnInit} from '@angular/core';
import {SachetAction} from '../../../model/sachet-action.model';
import {SachetTypeEnum} from '../../../constants/sachet-type.enum';
import {UserService} from '../../../services/user.service';
import {SachetStockService} from '../../../services/sachet-stock.service';
import {ActionTypeEnum} from '../../../constants/action-type.enum';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

    searching: boolean = false;
    action: SachetAction = new SachetAction();
    actions: SachetAction[] = [];
    filteredActions: SachetAction[] = [];
    sachetsTypes: string[] = [SachetTypeEnum.RED, SachetTypeEnum.YELLOW];
    actionTypes: string [] = [ActionTypeEnum.EDITED_STOCK, ActionTypeEnum.STOCK_ADDICTION, ActionTypeEnum.DELIVERIES_SACHETS];

    sachetTypeFilter: string;
    actionTypeFilter: string;

    constructor(private userService: UserService,
                private sachetService: SachetStockService) {

    }

    getActions() {
        return this.actions.sort((a, b) => b.dateTimestamp - a.dateTimestamp);
    }

    filterActions() {
        if (this.sachetTypeFilter) {
            console.log(this.filteredActions);
            this.actions = this.filteredActions.filter(action => action.sachetType === this.sachetTypeFilter);
        }

        if (this.actionTypeFilter) {
            this.actions = this.filteredActions.filter(action => action.actionType === this.actionTypeFilter);
        }
    }

    clearFilters() {
        this.sachetTypeFilter = null;
        this.actionTypeFilter = null;
        this.sachetService.getActionsByOrganizationId(this.user.organizationModel.id).subscribe(values => {
            this.actions = [];
            this.actions = values;
        });
    }

    get user() {
        return this.userService.getLocalStorageUser();
    }

    getClass(counter: number, actionType?: string) {
        if (actionType) {
            return 'black';
        }
        if (counter < 0) {
            return 'negative';
        } else {
            return 'positive';
        }
    }

    getCounterLabel(counter: number, actionType?: string) {
        if (actionType === ActionTypeEnum.EDITED_STOCK) {
            return counter;
        }
        if (counter < 0) {
            return counter;
        } else {
            return `+${counter}`;

        }
    }

    ngOnInit(): void {
        this.sachetService.getActionsByOrganizationId(this.user.organizationModel.id).subscribe(values => {
            this.actions = [];
            this.actions = values;
            this.filteredActions = [...this.getActions()];
        });
    }

}
